import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    empty: [],
    index: 0
  },
  mutations: {
    addempty(state, cart) {
      state.empty.push(cart)
    },
    change(state, index) {
      state.index = index
    }
  },
  actions: {},
  modules: {}
})
// <!-- {{$store.state.empty}} -->